import type { Dictionary } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import type { Maybe } from '@graphql-tools/utils';

@Entity()
export class QuarterNoteQuestionFilter extends AdornisFilter {
  public static override _class = 'QuarterNoteQuestionFilter';

  constructor(doc: PartialEntityData<QuarterNoteQuestionFilter>) {
    super(doc);
  }

  @Field(() => String)
  meetingNoteID: Maybe<string>;

  @Field(() => String)
  category: Maybe<string>;

  @Field(() => String)
  year: Maybe<string>;

  override getMongoFilter(): Dictionary<any> {
    let criteria: Array<any> = [];
    const filterObj = this.toObject();

    if (filterObj.meetingNoteID) {
      criteria.push({
        meetingNoteID: filterObj.meetingNoteID,
      });
    } else {
      // dont get any things from db until a meetingNotID is defined
      criteria.push({ _class: '' });
    }

    if (filterObj.category) {
      criteria.push({
        category: filterObj.category,
      });
    }

    if (filterObj.year) {
      criteria.push({
        year: filterObj.year,
      });
    }

    criteria = criteria.filter(c => c);
    return criteria.length ? { $and: criteria } : { _class: '' };
  }
}
